import {
  Target,
  TableProperties,
  Map,
  CircleDot,
  Sparkles,
} from "lucide-react";

const eventIcons = {
  "Table Tennis": TableProperties,
  "Basket Shot": CircleDot,
  Dart: Target,
  "Treasure Hunt": Map,
};

const eventImages = {
  "Table Tennis": "/images/table-tennis.png",
  "Basket Shot": "/images/basket-shot.png",
  Dart: "/images/dart.png",
  "Treasure Hunt": "/images/treasure-hunt.png",
};

export function EventCard({ event }) {
  const Icon = eventIcons[event.name?.trim()] || Target;
  const image = eventImages[event.name?.trim()];

  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 transform hover:-translate-y-1">
      {/* 🔥 Image Header */}
      <div
        className="relative p-6 text-white bg-cover bg-center"
        style={{
          backgroundImage: `url(${image})`,
        }}
      >
        {/* ✅ Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Content */}
        <div className="relative flex items-center gap-4">
          <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
            <Icon className="w-8 h-8" />
          </div>
          <h3 className="text-2xl font-bold">{event.name}</h3>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            About
          </h4>
          <p className="text-gray-700 leading-relaxed">{event.description}</p>
        </div>

        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            Rules
          </h4>
          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {event.rules}
          </p>
        </div>

        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-4 rounded-lg border border-yellow-200">
          <h4 className="text-sm font-semibold text-orange-700 uppercase tracking-wide mb-2 flex items-center gap-2">
            <Sparkles className="w-4 h-4" />
            Prizes
          </h4>
          <p className="text-gray-800 font-medium">{event.prizes}</p>
        </div>
      </div>
    </div>
  );
}
